export const MakeAnExternalUserIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="1.75" y="1.75" width="14.5" height="14.5" rx="3.25" stroke="black" strokeWidth="1.5" />
			<path
				d="M6.4974 8.16699C6.95763 8.16699 7.33073 7.7939 7.33073 7.33366C7.33073 6.87342 6.95763 6.50033 6.4974 6.50033C6.03716 6.50033 5.66406 6.87342 5.66406 7.33366C5.66406 7.7939 6.03716 8.16699 6.4974 8.16699Z"
				fill="black"
			/>
			<path
				d="M12.3307 7.33366C12.3307 7.7939 11.9576 8.16699 11.4974 8.16699C11.0372 8.16699 10.6641 7.7939 10.6641 7.33366C10.6641 6.87342 11.0372 6.50033 11.4974 6.50033C11.9576 6.50033 12.3307 6.87342 12.3307 7.33366Z"
				fill="black"
			/>
			<path
				d="M7.14152 10.9716C6.85264 10.6195 6.33347 10.5643 5.97682 10.8496C5.61743 11.1371 5.5602 11.6628 5.84771 12.0222L5.92143 12.1074C5.96076 12.1504 6.01481 12.2065 6.0837 12.271C6.22113 12.3999 6.41986 12.5648 6.68073 12.7278C7.20577 13.056 7.98174 13.3753 8.9974 13.3753C10.0131 13.3753 10.789 13.056 11.3141 12.7278C11.5749 12.5648 11.7737 12.3999 11.9111 12.271C11.98 12.2065 12.034 12.1504 12.0734 12.1074L12.1481 12.0209C12.4356 11.6615 12.3774 11.1371 12.018 10.8496C11.6613 10.5643 11.1422 10.6195 10.8533 10.9716L10.8433 10.9828C10.8306 10.9967 10.8065 11.0221 10.7712 11.0551C10.7003 11.1216 10.5865 11.2171 10.4307 11.3145C10.1224 11.5072 9.64841 11.7087 8.9974 11.7087C8.34639 11.7087 7.87235 11.5072 7.56406 11.3145C7.40827 11.2171 7.2945 11.1216 7.2236 11.0551C7.18831 11.0221 7.16424 10.9967 7.15148 10.9828L7.14152 10.9716Z"
				fill="black"
			/>
		</svg>
	)
}
